import { useTranslation } from 'react-i18next';
import { LINK_TONES } from '@platform/engine/form/navigator/graphColors';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { useLinkTypeUsageQuery } from '@platform/state/api';
import { SysTable } from '../system/SysTable';
import { SystemPage } from '../system/SystemPage';
import { useCustomizationScope } from '../system/useCustomizationScope';
import { linkTypeInverse } from './linkTypeKeys';
import './customize.css';

/**
 * «Типи зв’язків» (прототип v4 G:L9656–9700, pgCustLinks): тип (кольорова пігулка), обернений тип, колір (квадрат і код) і «У користуванні» —
 * скільки кінців зв'язків цього типу є в просторі (GET /link-types/usage: «Блокує» на одному записі й «Заблоковано» на іншому). Дев'ять типів
 * платформи фіксовані; глобально кількостей немає.
 */
export function CustLinksPage() {
  const { t } = useTranslation();
  const { ws } = useWorkspaceParams();
  const global = useCustomizationScope(ws).scope === 'global';
  const { data: usage } = useLinkTypeUsageQuery(ws, { skip: !ws || global });
  const rows = Object.entries(linkTypeInverse).map(([key, inverse]) => {
    const tone = LINK_TONES[key] ?? '#64748b';
    const used = usage?.find((u) => u.linkType === key)?.count ?? 0;
    return {
      key,
      cells: [
        <span key="t" className="cu-link" style={{ background: tone }}>{t(`linkTypes.${key}`)}</span>,
        <span key="i" className="sp-muted">{t(`linkTypes.${inverse}`)}</span>,
        <span key="c" className="cu-swatch"><span className="cu-swatch__box" style={{ background: tone }} aria-hidden="true" /><span className="sp-mono">{tone}</span></span>,
        <span key="u" className="sp-mono">{global ? '—' : usage ? used : '…'}</span>,
      ],
    };
  });
  return (
    <SystemPage title={t('sysPages.sections.links')} sub={t('sysCust.links.sub')}>
      <div className="cu-links">
        <SysTable columns="minmax(150px, 1.4fr) minmax(150px, 1.4fr) 120px 80px" minWidth={560} rows={rows} label={t('sysPages.sections.links')}
          head={[t('sysCust.links.type'), t('sysCust.links.inverse'), t('sysCust.links.colour'), t('sysCust.links.inUse')]} />
      </div>
    </SystemPage>
  );
}
